import React from 'react';
export default function IntroModuleL({ onContinue, onHome, onGlossary }) {

  return (
    <div style={{ maxWidth: '600px', margin: '3rem auto', padding: '1.5rem', lineHeight: 1.6 }}>
      {/* Home Button */}
      <div style={{ position: 'absolute', top: '1rem', left: '1rem' }}>
        <button
          onClick={onHome}
          style={{
            display: 'block',
            marginBottom: '0.5rem',
            padding: '0.6rem 1rem',
            width: '200px',
            backgroundColor: '#eee',
            border: '1px solid #ccc',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          🏠 Home
        </button>

        <button
          onClick={onGlossary}
          style={{
            display: 'block',
            marginBottom: '0.5rem',
            padding: '0.6rem 1rem',
            width: '200px',
            backgroundColor: '#eee',
            border: '1px solid #ccc',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          📘 Glossary
        </button>

      </div>

      <h1 style={{ fontSize: '2rem', textAlign: 'center' }}>
        Welcome to the <span style={{ color: '#149854' }}>Cogello</span> Pilot
      </h1>

      <p>
        This pilot simulates a rapid, web-based cognitive screening for individuals who may have sustained a traumatic brain injury (TBI) due to personal injury. It is designed to help attorneys and legal teams identify potential cognitive impairments relevant to their client’s case.
      </p>

      <p>
        The assessment is grounded in neuroscience-backed cognitive paradigms.
      </p>

      <h2 style={{ fontSize: '1.5rem' }}>Target Population</h2>
      <p>
        Individuals with suspected mild-to-moderate TBI due to accidents or incidents involving potential cognitive consequences, such as motor vehicle collisions, falls, or assaults.
      </p>

      <h2 style={{ fontSize: '1.5rem' }}>Administration</h2>
      <p>
        The screening is self-paced, web-based, and takes approximately 10 minutes. Users should complete the assessment in one sitting, using a desktop or laptop in a quiet, distraction-free environment. The test should only be taken once to preserve the validity of results.
      </p>

      <h2 style={{ fontSize: '1.5rem' }}>Included Modules</h2>
      <ul>
        <li><strong>Go/No-Go</strong> measures attention and response inhibition by requiring users to respond only to target stimuli</li>
        <li><strong>1-Back</strong> assesses working memory and sustained attention through a matching task</li>
        <li><strong>Stroop</strong> evaluates executive control and interference resolution by prompting responses to font color rather than word meaning</li>
        <li><strong>Trail Making</strong> tests processing speed and set-shifting using sequence navigation tasks (Part A and B)</li>
        <li><strong>PHQ-9</strong> screens for depressive symptoms that may affect cognition or quality of life</li>
      </ul>

      <h2 style={{ fontSize: '1.5rem' }}>Stimuli & Scoring</h2>
      <p>
        Tasks are administered using visual cues (colors, letters, numbers) and scored automatically based on accuracy, reaction time, and error patterns. Interpretation thresholds are derived from standard performance distributions but are continuously refined to ensure clinical utility.
      </p>

      <h2 style={{ fontSize: '1.5rem' }}>Disclaimer</h2>
      <p>This cognitive screening is not a formal diagnostic tool. It provides:</p>
      <ul>
        <li><strong>Objective evidence</strong> of potential impairment relevant to cognitive damages</li>
        <li><strong>Quick decision support</strong> for attorneys evaluating whether to refer for full neuropsychological assessment</li>
        <li><strong>Domain-specific insight</strong> into deficits that could affect work capacity, daily functioning, or quality of life</li>
      </ul>
      <p>
        Scores should be interpreted within the broader legal and clinical context of each individual case.{' '}
        <strong>No personal data or responses are stored during this pilot.</strong>{' '}
        User input remains local and is not saved or transmitted.
      </p>

      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <button
          onClick={onContinue}
          style={{
            backgroundColor: '#149854',
            color: '#fff',
            border: 'none',
            padding: '0.75rem 2rem',
            fontSize: '1.1rem',
            borderRadius: '8px',
            cursor: 'pointer'
          }}
        >
          Begin Assessment
        </button>
      </div>
    </div>
  );
}
